import { FC, useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  useMediaQuery,
  Typography,
  Divider,
  Button
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import useStyles from "../Styles/ProjectDetailStyles";
import Footer from "../SubComponents/Footer";
import AdminHeader from "../SubComponents/AdminHeader";
import InvestStepper from "./InvestStepper";
import InvestDetails from "./InvestNew";
import AlertContext from "../../store/Alert/AlertContext";
import { useLocation, useParams } from "react-router";
import { useHistory } from "react-router-dom";
import graphQLClient from "../../utils/authHeader";
import gql from "graphql-tag";
import { getSymbol } from "../../store/Wallet/WalletFunction";
import { Pledge } from "../../interfaces";
import BackButton from "../../helpers/BackButton";
import { getTokenBalance } from "../../utils/web3/callHelpers";
import { useAccount } from "wagmi";
import InvestActionCards from "./InvestActionCards";
import PoolContext from "../../store/Pool/PoolContext";
import AuthContext from "../../store/Auth/AuthContext";
import { GET_POOL } from "../../utils/queries/pool/getPoolQuery";

const Invest: FC<any> = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const { setAlert } = useContext<any>(AlertContext);
  const { isAuth } = useContext<any>(AuthContext);
  const { userPledges, getUserListPledge } = useContext<any>(PoolContext);
  const [dataa, setDataa] = useState<any>();
  const [error, setError] = useState<any>();
  const [stableCoinOption, setStableCoinOption] = useState<any>([]);
  const [tokenBalances, setTokenBalances] = useState<any>([]);
  const history = useHistory();
  const { address: account, chain } = useAccount();
  const [invest, setInvest] = useState<null | Pledge>(null);

  let { id }: any = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');

  const [tickets, setTickets] = useState<number>(0);

  useEffect(() => {
    const variables = {
      id: id,
      code: code
    };
    
    if (isAuth) getUserListPledge();
    graphQLClient
      .request(GET_POOL, variables)
      .then((data) => {
        setDataa(data);
      })
      .catch((err) => {
        setError(err.response.message);
      });
  }, []);

  useEffect(() => {
    if (userPledges && userPledges.length > 0 && id) {
      const pledge = userPledges.find((pledge: any) => pledge.poolId === id);
      setInvest(pledge);
    }
  }, [id, userPledges])

  useEffect(() => {
    if (!dataa) return;
    if (account && chain) {
      dataa.pool.networks.map(async (network: any) => {
        getTokenBalance(network.networkId, account, network.token)
          .then((balance) => {
            setTokenBalances((balances: any) => [balance]);
          })
          .catch((err: any) => console.log(err));
        let symbol = await getSymbol(network.networkId, network.token);
        setStableCoinOption((stableCoinOption: any) => [
          ...stableCoinOption,
          symbol,
        ]);
      });
    }
  }, [dataa, account, chain]);

  useEffect(() => {
    if (error) {
      setAlert(error, "error");
    }
  }, [error]);

  return (
    <>
      <AdminHeader isProject={true} />
      {!isActive && (
        <>
          <InvestStepper />
          <Box mt={3}>
            <Divider />
          </Box>
        </>
      )}

      <Box
        className={classes.projectdetail}
        mt={isActive ? 3 : 5}
        minHeight={"54vh"}
        component="section"
      >
        <Box pb={isActive ? 3 : 8}>
          <Container fixed>
            <BackButton goBack investBtn={invest} />
            <Grid
              container
              direction={isActive ? "column-reverse" : "row"}
              justifyContent="space-between"
              style={{ position: !isActive ? "relative" : "static" }}
            >
              <Grid item md={6} lg={7} xs={12} sm={12}>
                <ProjectPoolHeading title1="Invest" title2="Funds" />
                {/* <Typography
                  variant="body1"
                  color="secondary"
                  className="text-darkslate"
                >
                  You got{" "}
                  <Typography
                    variant="body1"
                    color="primary"
                    className="fw-bold"
                    component="span"
                  >
                    ${invest?.whitelist}
                  </Typography>{" "}
                  individual cap to contribute in {dataa?.pool?.name}
                </Typography> */}

                {dataa?.pool && (
                  <>
                    <InvestDetails
                      id={dataa?.pool?.id}
                      ticker={dataa?.pool.ticker}
                      image={dataa?.pool?.image}
                      name={dataa?.pool?.name}
                      totalCap={dataa?.pool?.totalCap}
                      totalRaised={dataa?.pool?.totalRaised}
                      networks={dataa?.pool?.networks}
                      allowedInvestment={invest?.whitelist}
                      stableCoinOption={stableCoinOption}
                      balancesOption={tokenBalances}
                      usdPerTicketValue={dataa?.pool?.usdPerTicketValue}
                      tickets={tickets}
                      setTickets={setTickets}
                      code={code}
                    />
                  </>
                )}
              </Grid>
              <Grid item md={4} lg={3} xs={12} sm={12}>
                <Box>
                  <Box>
                    <Typography variant="h6">Summary</Typography>
                    <Typography
                      variant="body1"
                      style={{
                        fontWeight: 400,
                        fontSize: "16px",
                      }}
                    >
                      You have got&nbsp;
                      {
                        !code && (
                          <>
                            <span style={{ color: "rgba(62, 184, 170, 1)" }}>
                              {`${
                                (invest?.whitelist ? invest?.whitelist : 0) /
                                dataa?.pool?.usdPerTicketValue
                              } winning tickets`}
                            </span>
                            &nbsp;and&nbsp;
                          </>
                        )
                      }
                      <span style={{ color: "rgba(62, 184, 170, 1)" }}>
                        {`$${invest?.whitelist}`}
                      </span>
                      &nbsp;individual cap to invest in&nbsp;
                      {dataa?.pool?.name}
                    </Typography>
                  </Box>
                  <Box>
                    <InvestActionCards
                      usdPerTicketValue={dataa?.pool?.usdPerTicketValue}
                      cap={invest?.whitelist}
                      code={code}
                    />
                    <Box mt={2} textAlign="center">
                      <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => history.push('/portfolio')}
                      >
                        See Portfolio
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default Invest;
